import { theme } from '@algoan/deep-dive/theme';
import { ComponentProps } from '@algoan/deep-dive/model';

export interface TickIconProps extends ComponentProps {
  id?: string;
  color?: string;
}

export const TickIcon = ({ id, color, ...props }: TickIconProps): JSX.Element => {
  return (
    <svg id={id} width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M5.01493 9.49254L1.25373 5.73134L0 6.98507L5.01493 12L15.7612 1.25373L14.5075 0L5.01493 9.49254Z"
        fill={color ?? theme.white}
      />
    </svg>
  );
};
